import React, { createContext, useContext, useState, useEffect } from 'react';

// Context für den globalen Editing-Status
const EditingContext = createContext();

// Provider-Komponente
export function EditingProvider({ children, user = null }) {
  const [showEditButtons, setShowEditButtons] = useState(false); // UI-Sichtbarkeit der Edit-Buttons
  const [isEditing, setIsEditing] = useState(false); // Aktiver Bearbeitungsmodus (stoppt Drag & Drop)

  // Edit-Buttons nur anzeigen wenn Benutzer angemeldet ist UND Edit-Berechtigung hat
  useEffect(() => {
    const canShowEditButtons = user && user.canEdit === true;
    if (!canShowEditButtons && showEditButtons) {
      setShowEditButtons(false);
      setIsEditing(false);
    }
  }, [user, showEditButtons]);

  // Wrapper für setShowEditButtons der Login-Status prüft
  const setShowEditButtonsSafe = (value) => {
    if (user && user.canEdit === true) {
      setShowEditButtons(value);
    } else {
      setShowEditButtons(false);
      setIsEditing(false);
    }
  };

  // Globaler Listener: PDF-Export schaltet Edit-Mode aus
  useEffect(() => {
    const handleDisableEdit = () => {
      setShowEditButtons(false);
      setIsEditing(false);
    };
    window.addEventListener('pdfExportDisableEditMode', handleDisableEdit);
    return () => {
      window.removeEventListener('pdfExportDisableEditMode', handleDisableEdit);
    };
  }, []);

  return (
    <EditingContext.Provider value={{ 
      showEditButtons, 
      setShowEditButtons: setShowEditButtonsSafe,
      isEditing, 
      setIsEditing,
      canEdit: user && user.canEdit === true,
      isLearner: user && user.isLearner === true,
      user: user // User verfügbar machen
    }}>
      {children}
    </EditingContext.Provider>
  );
}

// Hook zum Verwenden des Editing-Contexts
export function useEditing() {
  const context = useContext(EditingContext);
  if (context === undefined) {
    throw new Error('useEditing must be used within an EditingProvider');
  }
  return context;
}
